import { VALID_TOKEN_VERSION } from 'config/constants';

const isTokenVersionValid = (version?: number) =>
  version === VALID_TOKEN_VERSION;

export default isTokenVersionValid;
